import {
  AudioHighlightMetadata,
  AudioHighlightMetadataType,
  KeywordSummaryAudioHighlightMetadata,
  ReasonSummaryAudioHighlightMetadata,
} from '@modules/feedback/components/AudioType/types';

export const isSummaryHighlightMetadataType = (
  highlight: AudioHighlightMetadata,
): highlight is
  | KeywordSummaryAudioHighlightMetadata
  | ReasonSummaryAudioHighlightMetadata => {
  return (
    highlight.type === AudioHighlightMetadataType.KeywordSummary ||
    highlight.type === AudioHighlightMetadataType.ReasonSummary
  );
};
